import React from 'react'

const ArticleSupertitle = ({article}) => {
    const Supertitle = () => {
        if (article.supertitle && article.supertitle !== "") {
            return (article.supertitle)
        } else if (article.tags && article.tags.length) {
            return (article.tags[0].name)
        } else if (article.category && article.category !== "") {
            return (article.category)
        }
    }

    return (
        <span className={`article_supertitle article_supertitle__${article.category}`}>
            <Supertitle />
        </span>
    )
}

export default ArticleSupertitle;